import React from 'react';
import { CheckIcon, SparkleIcon } from 'lucide-react';
import { CheckoutButton } from './Button';
import { ProductName } from './ProductName';
import { Ornament } from './Ornament';
import { PriceTag } from './PriceTag';
const frictionPoints = ['No more hours searching for the next combination.', 'No more disconnected teaching ideas.', 'No more repeating the same class because planning time ran out.', 'No more wondering what progression should come next.', 'No more starting every week from an empty page.'];
const included = ['6 Complete Instructor Volumes', '150 Ready-to-Teach Salsa & Bachata Classes', '100% Visual Core Teaching Material', 'Salsa Technique', 'Bachata Technique', 'Partnerwork', 'Connection', 'Leading & Following', 'Turns & Hand Changes', 'Footwork & Shines', 'Body Movement & Styling', 'Musicality', 'Combinations', 'Class Structure', 'Corrections', 'Student Progression', '5 Professional Bonus Guides', 'Immediate Digital Access', 'PDF Format'];
export function FinalCTA() {
  return <section className="bg-ink px-4 py-20 text-cream sm:py-28" data-id="element-86" data-mp="2c70ztsnlefs8">
      <div className="mx-auto max-w-4xl" data-id="element-87" data-mp="2h4j3p4mr64td">
        <div className="text-center" data-id="element-88" data-mp="2m2u9n49xfv6b">
          <h2 className="text-3xl font-semibold leading-tight text-gold sm:text-4xl" data-id="element-89" data-mp="2m1sxsxl374nj">
            Next week you can keep planning every class from scratch…
            <br data-id="element-90" data-mp="2v3ip83eyy3lb" />
            <span className="italic text-cream" data-id="element-91" data-mp="2v427xmcg0w0e">
              Or you can open a complete system and already know where to
              start.
            </span>
          </h2>
          <Ornament className="mt-6" data-id="element-92" data-mp="30096uv6f978u" />
          <div className="mx-auto mt-10 max-w-2xl rounded-xl border border-white/10 bg-white/[0.03] p-7 text-left" data-id="element-93" data-mp="34t2blj1w4fkx">
            <ul className="space-y-3" data-id="element-94" data-mp="39r3t3zjo46ua">
              {frictionPoints.map(point => <li key={point} className="flex gap-3 text-sm leading-6 text-cream/80" data-id="element-95" data-mp="3esjbtkydi19i">
                  <SparkleIcon size={16} className="mt-1 shrink-0 text-gold" aria-hidden="true" data-id="element-96" data-mp="3ir0hs16255pc" />
                  {point}
                </li>)}
            </ul>
          </div>
          <p className="mx-auto mt-10 max-w-3xl font-display text-3xl font-semibold text-champagne" data-id="element-97" data-mp="1shghb2v446z3">
            Salsa & Bachata Instructor Ready does not replace your knowledge as
            an instructor.
          </p>
          <p className="mx-auto mt-4 max-w-2xl text-base leading-7 text-cream/70" data-id="element-98" data-mp="22gxoxptxcuxp">
            It gives you a system for using that knowledge with greater
            structure, consistency and efficiency.
          </p>
        </div>

        <div className="mt-14 rounded-2xl border border-gold/50 bg-ink-soft p-7 shadow-luxe sm:p-11" data-id="element-99" data-mp="27e7bmxpxishu">
          <h3 className="text-center text-3xl font-semibold text-gold" data-id="element-100" data-mp="h0yln4zca8di">
            Everything Included
          </h3>
          <Ornament className="mt-4" data-id="element-101" data-mp="d0y95pvsw793" />
          <ul className="mt-8 grid gap-x-8 md:grid-cols-2" data-id="element-102" data-mp="d1zkzwkn4xrv">
            {included.map(item => <li key={item} className="flex items-baseline gap-3 border-b border-gold/15 py-3" data-id="element-103" data-mp="2y2omocgmd47">
                <CheckIcon size={15} className="shrink-0 translate-y-0.5 text-gold" aria-hidden="true" data-id="element-104" data-mp="3pc2h6t8nyjrd" />
                <span className="text-sm font-medium leading-6 text-cream/90" data-id="element-105" data-mp="3fdd21885jdet">
                  {item}
                </span>
              </li>)}
          </ul>
          <p className="mt-6 text-center text-xs font-medium uppercase tracking-[0.1em] text-cream/60" data-id="element-106" data-mp="3kdr7ciidc995">
            Immediate Access · Complete Digital PDF Bundle
          </p>

          <div className="mt-10 rounded-xl border border-gold/50 bg-wine px-6 py-9 text-center" data-id="element-107" data-mp="3bckt6g36zaj2">
            <p className="font-display text-3xl font-semibold text-cream" data-id="element-108" data-mp="14mmwmg01fra6">
              <ProductName script accentClassName="text-champagne" data-id="element-109" data-mp="19kohn6h0y0oa" />
            </p>
            <p className="mx-auto mt-4 max-w-xl font-display text-xl italic leading-8 text-cream" data-id="element-110" data-mp="35nb4n27biwfb">
              The Complete 6-in-1 Visual Teaching System for Salsa & Bachata
              Instructors
            </p>
            <p className="mx-auto mt-3 max-w-xl text-sm leading-6 text-cream/75" data-id="element-111" data-mp="2volqnkijlw4c">
              150 Ready-to-Teach Classes • 6 Complete Volumes • 100% Visual
              Core Material • 5 Professional Bonus Guides
            </p>
            <p className="mt-5 text-xs font-bold tracking-[0.2em] text-champagne" data-id="element-112" data-mp="2mq031ay7rqwp">
              SEE IT. CHOOSE IT. TEACH IT.
            </p>
          </div>

          <div className="mt-10 flex flex-col items-center text-center" data-id="element-113" data-mp="2cy43rwke5uqw">
            <PriceTag data-id="element-114" data-mp="27zsvvrdnpubb" />
            <CheckoutButton className="mt-7" data-id="element-115" data-mp="280ke80i8tvjn">
              GET SALSA & BACHATA INSTRUCTOR READY NOW
            </CheckoutButton>
            <p className="mt-5 text-xs text-cream/60" data-id="element-116" data-mp="23xo28sn7kxoo">
              Immediate Access · Complete Digital PDF Bundle
            </p>
          </div>
        </div>
      </div>
    </section>;
}